import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  Grid,
  InputBase,
  Stack,
  Select,
  MenuItem,
  Typography,
  InputAdornment,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField
} from '@mui/material';

import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
// material icons
import CloseIcon from '@mui/icons-material/Close';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// components
// import { loginApi } from '../../Apis';
import { loginApi } from '../utils/Apis';
import { setApiError } from '../store/Slice/Error/ErrorSlice';
import partnerService from './services/partnerService';
import { getLoginData } from '../store/Slice/Login/LoginSlice';
import useLoginSelector from '../store/Slice/Login/LoginSelector';
import { saveApiData } from '../store/Slice/Global/GlobalSlice';

// import { getLoginData } from '../store';

const { LoginForm } = partnerService;

function Login() {
  const [emailAddr, setEmailAddr] = useState();
  const [password, setPassword] = useState();
  const [open, setOpen] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [selectCriteria, setSelectCriteria] = useState('dsa');
  const [newUserCred, setNewUserCred] = useState(true);
  const [newUserCredDialog, setNewUserCredDialog] = useState(false);
  const [inactiveUserDialog, setInactiveUserDialog] = useState(false);
  const [openForgotPasswordDialog, setOpenForgotPasswordDialog] = useState(false);

  const [forgetPassMail, setForgetPassMail] = useState('');
  const [forgetPassMobile, setForgetPassMobile] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { LoginData } = useLoginSelector();
  sessionStorage.setItem('loginMail', emailAddr);

  const handleLogin = async () => {
    // if (newUserCred) {
    //   setNewUserCredDialog(true);
    //   return;
    // }
    if (!emailAddr || emailAddr.trim() === '') {
      setOpen(true);
      setValidationMsg('Please enter your E-Mail address');
      return false;
    }
    if (!password || password?.trim() === '') {
      setOpen(true);
      setValidationMsg('Please enter your password');
    }
    // if (password.length > 6 && password.length < 24) {
    //   const regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,24}$/;
    //   if (!regularExpression.test(password)) {
    //     setOpen(true);
    //     setValidationMsg(
    //       'Password must be alphanumeric, should contain at least one capital letter, one number, one special character'
    //     );
    //   }
    // } else {
    //   setOpen(true);
    //   setValidationMsg(
    //     'Password must be of minimum length of 6 characters and max. length of 24 characters'
    //   );
    // }

    const credential = {
      username: emailAddr,
      password: password
    };

    // const loginResponse = await LoginForm(credential);
    const loginResponse = await dispatch(getLoginData(credential));
    if (loginResponse.status !== 'I') {
      if (loginResponse?.isPasswordUpdated === true || loginResponse?.message === 'GRANTED') {
        const loginResponseData = loginResponse;

        setTimeout(() => navigate('/leads', { replace: true }), 200);
      } else if (newUserCred) {
        setNewUserCredDialog(true);
        return '';
      }
    } else {
      setInactiveUserDialog(true);
      return '';
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    checkLogin();
  }, []);
  // console.log('sss LoginData', LoginData);
  const checkLogin = async () => {
    if (LoginData?.isPasswordUpdated === true) {
      // alert('in check login area');
      navigate('/leads', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  const handleUpdatePassword = () => {
    setNewUserCredDialog(false);
    navigate('/update-password', { replace: true });
  };

  async function handleForgetPassword() {
    const credential = {
      email: forgetPassMail,
      mobile: forgetPassMobile
    };
    if (!forgetPassMail || !forgetPassMobile) {
      dispatch(setApiError('Please Enter Email or Password'));
      return;
    }
    const forgetPasswordResponse = await dispatch(
      saveApiData(loginApi?.forgetPassword, credential)
    );
    if (forgetPasswordResponse?.status === 'success') {
      dispatch(setApiError('Reset Link is sent registered mail Id.'));
      setOpenForgotPasswordDialog(false);
    }
  }

  return (
    <Box className="LoginOuter" sx={{ width: '100%', height: '100vh' }}>
      <Container maxWidth="fullWidth" disablegutters="true">
        <Stack>
          <Grid
            container
            className="loginInner"
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item md={6} container justifyContent="center" alignContent="center">
              <Grid item xs={11} sm={9} md={7}>
                <Box container>
                  <img
                    src="../../static/logos/realValueLogo.jpg"
                    alt="Kalolytic Logo"
                    className="loginLogo"
                    style={{ height: '69px' }}
                  />
                </Box>
                <Typography variant="h4" className="loginTitle">
                  Loan Management System
                </Typography>
                <Typography variant="body2" className="loginSubTitle">
                  by Kalolytic Solutions
                </Typography>
                <Typography variant="h5" className="mb-1">
                  Sign In
                </Typography>
                <Typography variant="subtitle2" className="mb-3">
                  Enter your credentials
                </Typography>
                <Typography variant="subtitle2" className="mb-1 mt-3">
                  Select Criteria
                </Typography>
                <Box className="mb-3">
                  <Select
                    fullWidth
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${selectCriteria}`
                    }}
                    value={selectCriteria}
                    onChange={(e) => {
                      setSelectCriteria(e.target.value);
                    }}
                  >
                    <MenuItem value=" " disabled>
                      Select Criteria
                    </MenuItem>
                    {/* <MenuItem value="bank">Bank</MenuItem> */}
                    <MenuItem value="dsa">DSA</MenuItem>
                  </Select>
                </Box>
                <FormControl fullWidth variant="standard" className="formGroupLogin mb-2">
                  <MailOutlineIcon className="formControlIcon" />
                  <InputBase
                    onChange={(e) => {
                      setEmailAddr(e.target.value);
                    }}
                    label="fullWidth"
                    placeholder="Email Address"
                    inputProps={{
                      'aria-label': 'email address',
                      className: 'formControlFull formControlFullE'
                    }}
                  />
                </FormControl>
                <TextField
                  variant="standard"
                  fullWidth
                  className="formGroupLogin mb-2"
                  InputProps={{
                    disableUnderline: true,
                    startAdornment: <LockOpenIcon className="formControlIcon" />,
                    endAdornment: (
                      <IconButton
                        sx={{ position: 'absolute', right: '18px' }}
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    )
                  }}
                  inputProps={{
                    'aria-label': 'password',
                    className: 'formControlFull formControlFullP'
                  }}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password"
                />
                {/* <Grid
                  container
                  sx={{
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '1rem'
                  }}
                >
                  <Grid item>
                    <Checkbox size="medium" />
                    <Typography variant="">Remember Me</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="" className="mr-1">
                      Forgot Password?
                    </Typography>
                    <Link to="/" className="loginLink">
                      Reset
                    </Link>
                  </Grid>
                </Grid> */}
                <Box className="mb-3" sx={{ textAlign: 'right' }}>
                  <Link
                    component="button"
                    onClick={() => setOpenForgotPasswordDialog(true)} // open your dialog
                    style={{
                      color: '#0d4689',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                    onMouseOver={(e) => (e.target.style.color = '#4fbbc8')}
                    onMouseOut={(e) => (e.target.style.color = '#0d4689')}
                  >
                    Forgot Password?
                    {/* <strong>Reset</strong> */}
                  </Link>
                </Box>

                <Button className="loginBtn mb-2" variant="button" onClick={(e) => handleLogin(e)}>
                  Sign In
                </Button>
                {/* <Box className="orDivider mb-2">or</Box> */}
                <Box className="mb-3 textAlignCenter">
                  Want to Become Partner Please &nbsp;
                  <Link to="/signup-new" className="">
                    <strong>Sign Up</strong>
                  </Link>
                  &nbsp;Here
                </Box>
                {/* <Box className="mb-3 textAlignCenter">
                  Want to Become Partner Please &nbsp;
                  <Link to="/signup-form/individual" className="">
                    <strong>Sign Up Individual</strong>
                  </Link>
                  &nbsp;Here
                </Box> */}
                <Divider className="mb-2" />
                {/* <Grid
                  container
                  sx={{
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '1rem'
                  }}
                >
                  <Grid item>
                    <Button className="mainBtn" variant="button" onClick={handleLogin}>
                      Login
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button className="mainBtn" variant="button">
                      Sign Up
                    </Button>
                  </Grid>
                </Grid> */}
                <Grid container>
                  <Typography variant="">
                    Copyright © 2026{' '}
                    {/* <a href="https://www.realvalue.loans/" target="_blank">
                      Kalolytic Solutions
                    </a> */}
                    {/* <a href="http://kalolytic.com/" target="_blank">
                      Kalolytic
                    </a> */}
                    <a href="https://www.kalolytic.com/lessEMI" target="_blank">
                      Kalolytic Solutions
                    </a>
                    . All rights reserved.
                  </Typography>
                  {/* <Typography variant="">
                    Copyright © 2020{' '}
                    <a href="https://www.lessemi.com/lessEMI" target="_blank">
                      Kalolytic Solutions
                    </a>
                    . All rights reserved.
                  </Typography> */}
                  {/* <Typography variant="">
                    Copyright © 2020{' '}
                    <a href="https://www.realvalue.loans/" target="_blank">
                      RealValue
                    </a>
                    . All rights reserved.
                  </Typography> */}
                  <Grid item>
                    {/* <Link href="/privacy-policy" target="_blank" className="loginLink mr-2"> */}
                    <Link
                      // to="/"
                      to="/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="loginLink mr-2"
                    >
                      Privacy Policy
                    </Link>
                    <Link
                      // to="/"
                      to="/term-conditions"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="loginLink"
                    >
                      Term of Use
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item md={6}>
              <Box className="loginBanner">
                <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                  <Grid item sm={11} md={10} lg={10}>
                    <Box>
                      <img
                        src="../../static/login/personImage.png"
                        alt="Person"
                        className="loginRightImg"
                      />
                    </Box>
                    <Divider className="mb-2" />
                    <Typography variant="subtitle1" className="loginRightText">
                      The Kpros of Prosperity and Profits brought to you by
                    </Typography>
                    <Typography variant="h4" className="loginRightTextB">
                      Kalolytic Solutions
                    </Typography>
                    <Divider className="mt-2" />
                    {/* <Typography variant="body">
                      The Kpros of Prosperity and Profits brought to you by   Kalolytic Solutions.
                    </Typography> */}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle className="popupTitle">
                <Typography variant="h6">&nbsp;</Typography>
                <IconButton onClick={(e) => setOpen(false)} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <Box py={1} px={4} textAlign="center">
                    <Typography variant="subtitle2">{validationMsg}</Typography>
                  </Box>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button variant="contained" className="mainBtn" onClick={handleClose}>
                  Retry
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              className="PopupBox"
              open={newUserCredDialog}
              onClose={(e) => setNewUserCredDialog(false)}
              fullWidth
            >
              <DialogTitle className="popupTitle">
                <Typography variant="h6">Update Password</Typography>
                <IconButton onClick={(e) => setNewUserCredDialog(false)} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Typography variant="body2">
                  You are required to sign in with updated password, <br /> please update your
                  password.
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleUpdatePassword} variant="contained" className="mainBtn">
                  Update Password
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              className="PopupBox"
              open={inactiveUserDialog}
              onClose={(e) => setInactiveUserDialog(false)}
              fullWidth
            >
              <DialogTitle className="popupTitle">
                <Typography variant="h6">Inactive User</Typography>
                <IconButton onClick={(e) => setInactiveUserDialog(false)} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Typography variant="body2">Your account is inactive.</Typography>
              </DialogContent>
            </Dialog>

            {/* forget password  */}
            <Dialog
              className="PopupBox"
              open={openForgotPasswordDialog}
              onClose={(e) => setOpenForgotPasswordDialog(false)}
              fullWidth
            >
              <DialogTitle className="popupTitle">
                <Typography variant="h6">Forget Password</Typography>
                <IconButton onClick={(e) => setOpenForgotPasswordDialog(false)} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <FormControl fullWidth variant="standard" className="formGroupLogin mb-2">
                  <MailOutlineIcon className="formControlIcon" />
                  <InputBase
                    onChange={(e) => {
                      setForgetPassMail(e.target.value);
                    }}
                    label="fullWidth"
                    size="small"
                    placeholder="Email Address"
                    inputProps={{
                      'aria-label': 'Enter Email Address',
                      className: 'formControlFull formControlFullE'
                    }}
                  />
                </FormControl>
                <FormControl fullWidth variant="standard" className="formGroupLogin mb-2">
                  <LockOpenIcon className="formControlIcon" />
                  <InputBase
                    onChange={(e) => {
                      setForgetPassMobile(e.target.value);
                    }}
                    size="small"
                    label="fullWidth"
                    type="number"
                    placeholder="Enter Mobile Number"
                    inputProps={{
                      'aria-label': 'password',
                      className: 'formControlFull formControlFullP'
                    }}
                  />
                </FormControl>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => handleForgetPassword()}
                  variant="contained"
                  className="mainBtn"
                >
                  Sumbit
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Stack>
      </Container>
    </Box>
  );
}

export default Login;
